/**
 * QR Codes Module Routes
 *
 * Auth-required routes live in the default export (loaded by module system into DefaultLayout).
 * Public routes live in publicRoutes (registered at top level in router/index.ts).
 *
 * Pattern follows src/modules/map/routes.ts
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

/**
 * Auth-required routes — injected into DefaultLayout by the module loader.
 */
const routes: RouteRecordRaw[] = [
    {
        path: '/qr-codes',
        component: ModuleLayout,
        meta: {
            moduleKey: 'qr_codes',
        },
        children: [
            {
                path: '',
                name: 'qr-codes-list',
                component: () => import('./views/QrCodeList.vue'),
                meta: {
                    title: 'All QR Codes',
                },
            },
            {
                path: 'create',
                name: 'qr-codes-create',
                component: () => import('./views/QrCodeCreate.vue'),
                meta: {
                    title: 'Add QR Code',
                    moduleKey: 'qr_codes',
                },
            },
            // analytics BEFORE :id to prevent "analytics" being captured as an ID
            {
                path: 'analytics',
                name: 'qr-codes-analytics',
                component: () => import('./views/QrCodeAnalytics.vue'),
                meta: {
                    title: 'QR Code Analytics',
                },
            },
            {
                path: ':id',
                name: 'qr-codes-detail',
                component: () => import('./views/QrCodeDetail.vue'),
                meta: {
                    title: 'QR Code Details',
                },
            },
        ],
    },
]

/**
 * Public routes — registered at the top level (outside DefaultLayout)
 * so they bypass the auth guard entirely.
 *
 * The backend handles QR redirects at api.sghredis.com/qr/:code.
 * For non-active states, the backend 302s to these frontend pages:
 *
 *   /qr/status/{not-found|expired|paused|scheduled|error}?code={code}
 *   /qr/verify?code={code}
 */
export const publicRoutes: RouteRecordRaw[] = [
    {
        path: '/qr/status/:reason',
        name: 'qr-status',
        component: () => import('./views/QrStatus.vue'),
        meta: {
            title: 'QR Code',
            requiresAuth: false,
        },
    },
    {
        path: '/qr/verify',
        name: 'qr-verify',
        component: () => import('./views/QrVerify.vue'),
        meta: {
            title: 'QR Code — Verify',
            requiresAuth: false,
        },
    },
]

export default routes
